<template>
  <div id="confirmed" class="mt-4">
    <label for="confirm" class="form-line"
      >Have you confirmed the above information is correct?</label
    >
    <b-form-radio-group name="confirm" v-model="confirmed">
      <b-form-radio :value="true">Yes</b-form-radio>
      <b-form-radio :value="false">No</b-form-radio>
    </b-form-radio-group>
    <br />
  </div>
</template>

<script>
export default {
  name: 'ConfirmSubmit',
  computed: {
    confirmed: {
      get() {
        return this.$store.state.confirmed;
      },
      set(val) {
        this.$store.commit('confirmed', val);
      },
    },
  },
};
</script>
